var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"btn-dark",style:({ width: _vm.width }),attrs:{"disabled":_vm.disabled,"depressed":"","color":"secondary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }